




































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import { Prop } from 'vue-property-decorator'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import { PanelUserService } from '@/modules/user/services/panel-user.service'
import {
  UserProfileNotificationsKeysModel,
  UserProfileVerifyKeysModel
} from '@/modules/user/models/user-resource.model'
import TelegramActivationButton from '@/modules/shared/components/panel/TelegramActivationButton.vue'
import NotificationToggleButton from '@/modules/notification/components/panel/NotificationToggleButton.vue'

@Component({
  metaInfo: {
    title: 'حساب کاربری'
  },
  components: {
    NotificationToggleButton,
    TelegramActivationButton,
    Toggle,
    BaseCard
  }
})
export default class Profile extends Vue {
  constructor(
    private readonly service: PanelUserService
  ) {
    super()
  }

  @Prop() notifications!: UserProfileNotificationsKeysModel
  @Prop() verifications!: UserProfileVerifyKeysModel
  @Prop() telegramBotActivation!: string

  updateNotificationPreferences(value) {
    this.service.updateNotificationPreferences({
      notifications: value
    })
  }

}
